import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import Loader from 'svg/loader.svg';
import { useAction } from 'hooks';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import VerifyCode from './VerifyCode';
import ConfirmTermsOfServicesByGuardian from './ConfirmTermsOfServicesByGuardian';
import EditGuardianEmail from './EditGuardianEmail';
import useConfirmEmailSteps from './useConfirmEmailSteps';
import ConfirmEmailPrevVersion from './ConfirmEmail';
import styles from './confirmEmail.pcss';
const ConfirmEmail = ({ email, password, returnUrl, isMinorMock })=>{
    useStyles(styles);
    const confirmEmailActivationType = useSelector(selectors.confirmEmailActivationType);
    const [guardianEmail, setGuardianEmail] = useState(email);
    const [CurrentView, setCurrentView] = useState(null);
    const unsetConfirmEmailActivationType = useAction(actions.unsetConfirmEmailActivationType);
    const { currentViewName, onEditGuardianEmail, onConfirmationCompleted } = useConfirmEmailSteps(isMinorMock);
    useEffect(()=>{
        switch(confirmEmailActivationType){
            case 'email':
                setCurrentView(/*#__PURE__*/ _jsx(ConfirmEmailPrevVersion, {
                    email: email,
                    password: password,
                    returnUrl: returnUrl
                }));
                break;
            case 'code':
                switch(currentViewName){
                    case 'ConfirmTermsOfServicesByGuardian':
                        setCurrentView(/*#__PURE__*/ _jsx(ConfirmTermsOfServicesByGuardian, {
                            onEditGuardianEmail: onEditGuardianEmail,
                            onConfirmationCompleted: onConfirmationCompleted,
                            guardianEmail: guardianEmail
                        }));
                        break;
                    case 'EditGuardianEmail':
                        setCurrentView(/*#__PURE__*/ _jsx(EditGuardianEmail, {
                            guardianEmail: guardianEmail,
                            setGuardianEmail: setGuardianEmail
                        }));
                        break;
                    case 'VerifyCode':
                        setCurrentView(/*#__PURE__*/ _jsx(VerifyCode, {
                            email: email,
                            returnUrl: returnUrl
                        }));
                        break;
                    default:
                        setCurrentView(null);
                }
                break;
            default:
                setCurrentView(null);
        }
    }, [
        confirmEmailActivationType,
        currentViewName
    ]);
    useEffect(()=>()=>{
            unsetConfirmEmailActivationType();
        }, []);
    if (!CurrentView) {
        return /*#__PURE__*/ _jsx(Loader, {
            className: "rotatingLoader  h-50"
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, 'pageContentBox'),
        children: CurrentView
    });
};
export default ConfirmEmail;
